import Repository from '../axios'
import {defaultPagination} from "../constants/config";

const resource = "/supplier";
export default {
  getListRmOrders(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/raw_material_orders?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getRmOrderDetails(id) {
    return Repository.get(`${resource}/raw_material_orders/${id}`)
  },
  statusChangeRmOrder(id, status, payload) {
    return Repository.put(`${resource}/raw_material_order/${id}/${status}`, payload)
  },
  statusChangeRmOrderItem(id, payload) {
    return Repository.put(`${resource}/raw_material_order_item/${id}/status`, payload)
  },
  changeRmOrderHandleType(id) {
    return Repository.put(`${resource}/raw_material_order/${id}/item_status_handle`)
  },
  getRmOrderPdfDetails(id) {
    return Repository.get(`${resource}/raw_material_order/${id}/purchase_order_pdf?timezone=Europe/London`)
  },
};
